import React from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  pulse: {
    backgroundColor: theme.palette.grey[300],
    animation: "$pulse 1.4s ease-in-out infinite",
  },
  "@keyframes pulse": {
    "0%": { opacity: 1 },
    "50%": { opacity: 0.5 },
    "100%": { opacity: 1 },
  },
  media: {
    height: 250,
  },
  line: {
    height: 16,
    borderRadius: 4,
    marginTop: theme.spacing(1),
  },
  lineShort: {
    width: "60%",
  },
}));

const EventCardSkeleton = () => {
  const classes = useStyles();

  return (
    <Grid item xs={12} sm={4}>
      <Card>
        <div className={`${classes.media} ${classes.pulse}`} />
        <CardContent>
          <div className={`${classes.line} ${classes.pulse}`} />
          <div className={`${classes.line} ${classes.lineShort} ${classes.pulse}`} />
        </CardContent>
      </Card>
    </Grid>
  );
};

export default EventCardSkeleton;
